export default "__VITE_ASSET__rgacmEcf__"